import React, {useEffect,useState} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import SummaryExtras from '../../components/Summary/SummaryExtras';
import CheckoutExtras from '../../components/Checkout/CheckoutExtras';
import { re } from '../../utilities/utilities';
import parse from 'html-react-parser';



const GatherInfo = ({handleSuccessfulSubmit,permissionEndpoint}) => {

      const [content,setContent]=useState([]);
      const [err,setErr]=useState([]);

      useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        fetch(`${process.env.REACT_APP_BACK}/api/${permissionEndpoint}?res=${urlParams.get('res')}` )
          .then(response => response.json())
          .then(response => {
            // if(response===null ){re("/");return;}
            // if(response.type==="error"){
            //   let e = <> <h1>{parse(String(response.error))}</h1> <p>{parse(String(response.help))}</p> <b><u>You are about to be redirected.</u></b></> 
            //   setErr(e);
            //   setTimeout(() => { re(); }, 7000);
            //   return;
            // }

            console.log(response);
            // console.log(JSON.parse(response));
            let e = false;
            setErr(e);
            setContent({
              'content':response.content,
              // ...response,
              // 'guest_order':JSON.parse(response.guest_order),
              // 'id':urlParams.get('id'),
              // 'res_id':urlParams.get('res'),
              // 'token':urlParams.get('t')
            });

          })
          .catch(err => console.error(err));

      },[]);

 
    return (
      <>
      {window.scrollTo(0, 0)}
      <div id="room-page" className='container br-5vh'>
        <div id="head">
          <Navbar />
        </div>

        {err!==false?
          <div className='user-msg'>{err}</div>
        : 
        <div className='flex col-body layout-60-40'>
          <div className='flex-col'>
              {parse(String(content.content))}
          </div>

          <div className=''>
              
        </div>

              
        </div>
        }
      </div>

    </>
  )

}

export default GatherInfo;